import React from "react";

const Header = () => {
  return (
    <header>
      <h1>Memory Card Game</h1>

    </header>
  );
};

export default Header;
